export default __webpack_public_path__ + "static/media/footerLogo.ff067cd4.svg";